import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the MyFilterPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'myFilterPipe',
})
export class MyFilterPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value, args) {
 
    
    let newValue = [];
	
	if(value){
		//Count how many words were passed in
		let wordCount = value.length;
		for(let i = 0; i < wordCount; i++){
		  if(value[i].key != 4){
			newValue.push(value[i]);
		  }
		}
	}
 
    return newValue;
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/my-filter/my-filter.ts